window.ParsleyConfig =
  excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], input[type=search], .ignore-parsley'
  focus: 'first'
  errorClass: 'js-error'
  errorsWrapper: '<div class="js-parsley-error-wrapper"></div>'
  errorTemplate: '<p></p>'
  errorsContainer: (el) ->
    $parent = el.$element.closest(".interaction, .sub-interaction")
    return $parent if $parent.length
    el.$element.closest("div")
  classHandler: (el) ->
    $parent = el.$element.closest(".interaction, .sub-interaction")
    return $parent if $parent.length
    el.$element.closest("div")

$ ->
  parseRequirement = (requirement) ->
    # copied from comparison.js
    if isNaN(+requirement)
      parseFloat jQuery(requirement).val()
    else
      +requirement

  window.Parsley
    .addValidator "uniqueinputcollection",
      validate: (value, selector) ->
        $inputs = $(selector).find("input:visible")
        count = $inputs.filter((i, el) ->
          $(el).val().toLowerCase().trim() == value.toLowerCase().trim()
        ).length
        count <= 1

    .addValidator "greaterthan",
      validate: (value, requirement) ->
        # copied from comparison.js
        return parseFloat(value) > parseRequirement(requirement)

    .addValidator "priceincrease",
      validate: (value, startingPrice) ->
        return parseInt(value) >= parseInt(startingPrice)

    .addValidator "afterorondate",
      validate: (value, selector) ->
        afterDate = moment(value, "MMM DD, YYYY")
        beforeDate = moment($(selector).val(), "MMM DD, YYYY")
        return afterDate.isSameOrAfter(beforeDate)

    .addValidator "afterdatetime",
      validate: (value, compareDateTime) ->
        inputDateTime = moment(value)
        compareDateTime = moment(compareDateTime)
        return inputDateTime.isAfter(compareDateTime)

    .addValidator "beforeorondatetime",
      validate: (value, compareDateTime) ->
        inputDateTime = moment(value)
        compareDateTime = moment(compareDateTime)
        return inputDateTime.isSameOrBefore(compareDateTime)

  window.Parsley
    .on "form:validated", ->
      $(".js-error select").on "select2:select", ->
        # select2 should validate on change
        $(@).parsley().validate()
        if $(@).parsley().isValid()
          $(@).off("select2:select")

      $(".js-error .js-date-picker, .js-error .js-time-picker").on "change", ->
        # date only and time only requires extra change bind to value
        # datetime-local in contently.ui has it's own change bind
        $(@).parsley().validate()

    .on "form:submit", (form) ->
      $form = form.$element

      if form.isValid()
        $submitButtons = $form.find("button, input[type=submit]").not("[type='button'], .disabled")

        if $submitButtons.length
          for button in $submitButtons
            contently.ui.disable_button_with_spinner(button)

      if $form.is("[data-remote]")
        $form.on "ajax:complete", ->
          # reset textarea if empty
          $visibleTextareas = $form.find("textarea:visible")
          if $visibleTextareas.length
            for textarea in $visibleTextareas
              if !$.trim($(textarea).val())
                $(textarea).css "height", ""

          # reset disabled buttons
          $disabledButtons = $form.find(".actions .disabled")
          if $disabledButtons.length
            for button in $disabledButtons
              contently.ui.enable_button(button)



// WEBPACK FOOTER //
// ./app/javascript/vendor/parsley-config.js.coffee